import { useEffect, useState } from "preact/hooks";
import { h } from "preact";
import { fromJsonApi, convertLegacyPerformanceEventResponse } from "./models";
import requestStore from "./request-store";
import { hide } from "@floating-ui/dom";

/**
 * @typedef {object} Props
 * @prop {import("./shared-types").StudentResponse} [studentResponse]
 * @prop {import("./shared-types").TeacherResponse | undefined} teacherResponse
 * @prop {import("./shared-types").ScoringData | undefined} scoringData 
 * @prop {function} didRender
 * @prop {boolean} readOnly
 * @prop {function} teacherResponseDidChange
 * @prop {function} teacherResponseDidFinishEdit
 * @prop {function(import("./shared-types").StudentResponse): void} responseDidChange
 * @prop {'teacher-facing' | 'student-facing' | 'preview' | 'student-facing-report'} mode
 * @prop {boolean | undefined} hideAllAnswers
 * @prop {boolean | undefined} hideCorrectAnswers
 * @prop {boolean | undefined} hidePoints 
 * @prop {boolean | undefined} hideResponse
 * @prop {string | undefined} dragScrollContainer 
 * @prop {any[]} [bodyDiff] 
 * @prop {string} [source]
 * @prop {import("./shared-types").ItemJSON} [data]
 * @prop {boolean} allowChoiceElimination
 * @prop {import("./shared-types").LegacyPerformanceEventResponse[]} [legacyPerformanceEventResponse]
 */


/**
 * 
 * @param {Props} props 
 */
export default function QuestionWrapper(props) {
    let [studentResponse, setStudentResponse] = useState(props.studentResponse);
    let [item, setItem] = useState(props.data ? fromJsonApi(props.data) : null);
    let [teacherResponse, setTeacherResponse] = useState(props.teacherResponse);
    useEffect(() => {
        if(!props.data) {
            fetchItem(props.source).then((data) => {
                if("assessment_item" in data) {
                  setItem(fromJsonApi(data.assessment_item));
                  setStudentResponse(data.student_response);
                  setTeacherResponse(data.teacher_response);
                } else {
                  setItem(fromJsonApi(data));
                }
            })
        }
    }, [])

    if(!item) {
        return <div class="item-player-loading"></div>
    }

    return h(item.component(props.mode), {
      item: item,
      didRender: props.didRender,
      readOnly: props.readOnly,
      updateStudentResponse: (response) => {
        props.responseDidChange(response);
        setStudentResponse(response);
      },
      studentResponse: props.legacyPerformanceEventResponse ? convertLegacyPerformanceEventResponse(props.legacyPerformanceEventResponse, item.data.attributes.response_type) : studentResponse,
      teacherResponseDidChange: props.teacherResponseDidChange,
      teacherResponseDidFinishEdit: props.teacherResponseDidFinishEdit,
      teacherResponse: teacherResponse,
      scoringData: props.scoringData,
      responseDidChange: props.responseDidChange,
      mode: props.mode,
      hidePoints: props.hidePoints,
      hideAllAnswers: props.hideAllAnswers,
      hideCorrectAnswers: props.hideCorrectAnswers,
      hideResponse: props.hideResponse,
      dragScrollContainer: props.dragScrollContainer,
      bodyDiff: props.bodyDiff,
      allowChoiceElimination: props.allowChoiceElimination,
      showBody: true
    })
}

  /**
   * @param {string} [source]
   * @returns Promise<import("./shared-types").ItemJSON | import("./shared-types").ReportItem>
   */
  function fetchItem(source) {
    if(!source) { throw new Error("Missing source or type + id options") }
    let request = requestStore.findRequest(source)
    if(request) {
        return request;
    }

    /**
     *  @type {(s: Response) => Promise<import("./shared-types").ItemJSON | import("./shared-types").ReportItem>}
     */
    let toJSON = (r) => {
      return r.json();
    }

    let promise = fetch(source, {
      credentials: "include"
    }).then(toJSON);

    requestStore.registerRequest(source, promise)

    return promise;
  }